// GENERATED FILE - DO NOT MODIFY

export enum GetUsersSortColumnDto {
    Name = "Name",
    Email = "Email",
    CompanyName = "CompanyName",
    LocationName = "LocationName",
    Status = "Status",
}